// extracted by mini-css-extract-plugin
export default {"form-wrapper":"styles_form-wrapper__xlaDe"};